<template lang="pug">
#select-laudo
    h2(v-if='tipos.length > 1') {{ $t('mensagens.laudos.selecioneTipoDeLaudo') }}
    el-select(v-if='tipos.length > 1')(
        v-model='laudoSelecionado',
        :placeholder="$t('mensagens.comuns.selecione')",
        @change='mudarLaudo',
        clearable,
        @clear='limparSelecao'
    )
        el-option(
            v-for='tipo in tipos',
            :key='tipo.id',
            :label='traduzirNomeLaudo(tipo.nome)',
            :value='tipo.id'
        )

</template>

<script>
import LaudoEmpresaService from '@/services/LaudoEmpresaService';
import { mapGetters } from 'vuex';
import EventBus from '@/utils/eventBus';
import { orderBy } from 'lodash';
import tradutorDeLaudos from '@/utils/tradutorDeLaudos';

const routesLink = [
    { id: 99, nomeComponent: 'LaudosDashboard'},
    { id: 1, nomeComponent: 'LaudosAgricola' },
    { id: 2, nomeComponent: 'LaudosBacenFiscalizacao' },
    { id: 3, nomeComponent: 'LaudosBenfeitorias' },
    { id: 4, nomeComponent: 'LaudosConformidadeAmbiental' },
    { id: 5, nomeComponent: 'LaudoCarbono' },
    { id: 6, nomeComponent: 'LaudoHistoricoAgricola' },
    { id: 7, nomeComponent: 'LaudoDiagnosticoAgricola' },
    { id: 8, nomeComponent: 'LaudoSupressaoVegetal' },
    { id: 9, nomeComponent: 'LaudoTecnicoAgricola' },
    { id: 10, nomeComponent: 'LaudoCroqui' },
    { id: 11, nomeComponent: 'LaudoBacenResolucao140' },
    { id: 12, nomeComponent: 'LaudoAvaliacaoFundiarias' },
    { id: 13, nomeComponent: 'LaudoAvaliacaoAreaProdutiva' },
    { id: 14, nomeComponent: 'LaudoAvaliacaoSocioambiental' },
    { id: 15, nomeComponent: 'LaudoRenovabio' }
];

export default {
    name: 'SelecionarLaudo',

    emits: ['laudoUnico'],

    data() {
        return {
            tipos: [],
            laudoSelecionado: ''
        };
    },

    computed: {
        ...mapGetters(['usuarioLogado'])
    },

    methods: {
        traduzirNomeLaudo(laudo) {
            return tradutorDeLaudos.traduzirLaudo(laudo);
        },

        async getTipoLaudo() {
            try {
                const response = await LaudoEmpresaService.buscarLaudosPorEmpresa(this.usuarioLogado?.idGrupo);
                this.tipos = response?.data?.itens;
                if (!this.tipos || this.tipos.length === 0 || this.usuarioLogado?.isAnalyst) {
                    const response2 = await LaudoEmpresaService.buscarTiposLaudo();
                    this.tipos = response2?.data?.itens;
                }

                this.tipos = orderBy(this.tipos, ['nome']);
                this.$emit('laudoUnico', this.tipos.length > 1 ? 'false' : 'true');
            } catch (error) {
                this.$notify.error({
                    message: this.$t('mensagens.laudos.erro.ocorreuUmerroAoBuscarTiposDeLaudo')
                });
            }

            if (this.$route?.name === 'Laudos') {
                const route = routesLink.find(r => r?.id === 99);
                this.$router.push({ name: route?.nomeComponent });
                EventBus.$emit('laudo-selecionado', 99);
            }

            const route = routesLink.find(r => r?.nomeComponent === this.$route?.name);
            if (route?.nomeComponent === 'LaudosDashboard') {
                EventBus.$emit('laudo-selecionado', 99);
            } else {
                this.laudoSelecionado = route?.id;
                EventBus.$emit('laudo-selecionado', this.laudoSelecionado);
            }
        },

        mudarLaudo() {
            const route = routesLink.find(r => r?.id === this.laudoSelecionado);
            this.$router.push({ name: route?.nomeComponent });
            EventBus.$emit('laudo-selecionado', this.laudoSelecionado);
        },

        limparSelecao() {
            const route = routesLink.find(r => r?.id === 99);
            this.$router.push({ name: route?.nomeComponent });
            EventBus.$emit('laudo-selecionado', 99);
            this.laudoSelecionado = '';
        }
    },
    async mounted() {
        await this.getTipoLaudo();
    }
};
</script>

<style scoped lang="scss">
#select-laudo {
    display: flex;

    align-items: center;
    justify-content: flex-start;

    gap: 8px;

    .el-select {
        min-width: 350px;
    }
}
</style>

<style>
.tabela-rodape-somatorio-laudos p {
    margin-bottom: 0;
    color: var(--primary);
    font-size: 15px;
    font-weight: 600;
    line-height: 16px;
    padding: 17px 0 15px 21px;
}
.el-pagination {
    padding: 16px 75px 16px 0;
    color: #3b3b3b;
}
.el-pager li.active {
    color: #00413c;
    font-weight: 600;
    font-size: 15px;
    background: #00413c24;
    background-color: var(--secondary) !important;
}
</style>
